import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "@simplecitizen/gdl-react-ui-components/dist/style.css";
import "./App.css";
import CheckPages from "./pages/check/index";
import PageNotFound from "./pages/404";
import DocumentUploadMobileHandoff from "./pages/check/DocumentUploadMobileHandoff";
import OneTrust from "./components/onetrust.tsx";
import ToastProvider from "./contexts/ToastProvider.tsx";
import OutageBanner from "./components/lib/outage-banner/OutageBanner.tsx";


const MainRoutes = () => {
  const outageMode = process.env.REACT_APP_OUTAGE_MODE === 'true';
  if (outageMode) {
    return (
      <div className="flex flex-col w-screen h-screen overflow-y-auto overflow-x-hidden">
        <OutageBanner />
      </div>
    );
  }
  return (
    <ToastProvider>
    <div className="flex flex-col w-screen h-screen overflow-y-auto overflow-x-hidden">     
      <Routes>
        <Route path="/" element={<PageNotFound />} />
        <Route path="/check/:checkId" element={<CheckPages />} />
        <Route path="*" element={<PageNotFound />} />
        <Route
          path="/document-upload/:checkId/mobile-handoff/:docId/:sessionId"
          element={<DocumentUploadMobileHandoff />}
        />
      </Routes>
    </div>
    </ToastProvider>
  );
};

function App() {
  useEffect(() => {
    console.log(`Git Hash: ${process.env.REACT_APP_GIT_HASH}`);
  }, []);
  return (
    <Router>
      <OneTrust />
      <MainRoutes />
    </Router>
  );
}

export default App;
